import React from 'react'

function EmailMailing() {
  return (
    <div>EmailMailing</div>
  )
}

export default EmailMailing